import { useTranslation } from "react-i18next";
import ClubScopeShell from "@/components/club-scope-shell";
import AccessForm from "./access-form";

export default function AccessPage() {
  const { t } = useTranslation();

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6 lg:py-8 max-w-3xl mx-auto space-y-6">
      <div>
        <h1 className="font-heading text-xl sm:text-2xl font-bold text-neutral-800 mb-1">
          {t("access.title")}
        </h1>
        <p className="text-sm text-neutral-500">{t("access.subtitle")}</p>
      </div>

      <ClubScopeShell>
        {(clubId) => <AccessForm clubId={clubId} />}
      </ClubScopeShell>
    </div>
  );
}
